/** Snippets de uso (API proposta) para papéis L1. */
const ATOM_USAGE = {
  'btn-confirm': {
    importName: 'ButtonConfirm',
    usage: `<ButtonConfirm appearance="accent" onClick={salvar}>
  Salvar
</ButtonConfirm>

{/* appearance: "accent" | "dark" | "withIcon" */}`,
  },
  'btn-cancel': {
    importName: 'ButtonCancel',
    usage: `<ButtonCancel appearance="outline" onClick={fechar}>
  Cancelar
</ButtonCancel>

{/* appearance: "outline" | "ghost" | "muted" */}`,
  },
  'btn-delete': {
    importName: 'ButtonDelete',
    usage: `<ButtonDelete appearance="filled" onClick={excluir}>
  Excluir
</ButtonDelete>

{/* appearance: "filled" | "outline" | "ghost" */}`,
  },
  'input-line': {
    importName: 'TextField',
    usage: `<TextField label="Nome" appearance="bordered" value={nome} onChange={setNome} />

{/* appearance: "bordered" | "underline" | "filled" */}`,
  },
  'input-area': {
    importName: 'TextArea',
    usage: `<TextArea label="Observação" appearance="simple" value={obs} onChange={setObs} />

{/* appearance: "simple" | "withCounter" | "resizable" */}`,
  },
  'input-mask': {
    importName: 'MaskedInput',
    usage: `<MaskedInput unmask mask="000.000.000-00" lazy={false} value={cpf} onAccept={setCpf} />

{/* CPF 000.000.000-00 · CNPJ 00.000.000/0000-00 · celular (00) 00000-0000 · moeda mask="R$ num" com bloco Number, radix "," */}`,
  },
  select: {
    importName: 'Select',
    usage: `import Select from 'components/Template/Input/Select'

<Select options={opts} value={status} onChange={setStatus} />

{/* react-select. O <select> nativo não é o das telas. */}`,
  },
  'select-async': {
    importName: 'AsyncSelect',
    usage: `<AsyncSelect label="Fornecedor" appearance="list" loadOptions={buscar} value={v} onChange={setV} />

{/* appearance: "list" | "withMeta" | "withCreate" */}`,
  },
  'select-multi': {
    importName: 'MultiSelect',
    usage: `<Select isMulti options={areas} value={sel} onChange={setSel} />

{/* O mesmo Select (react-select), com isMulti. */}`,
  },
  date: {
    importName: 'DateField',
    usage: `<DateField label="Data" appearance="single" value={data} onChange={setData} />

{/* appearance: "single" | "range" | "dateTime" */}`,
  },
  toggle: {
    importName: 'Switch',
    usage: `<Switch label="Ativo" appearance="classic" checked={ativo} onChange={setAtivo} />

{/* appearance: "classic" | "yesNo" | "checkbox" */}`,
  },
  kanban: {
    usage: `{/* Sem componente compartilhado.
   Referência viva: pages/TechnicalDep/GestaoAtividades.
   Colunas = status. Contagem em cada uma. + só na primeira.
   Cartão: alça, título, uma linha secundária.
   Arrastar muda a coluna ou a ordem (marca antes/depois).
   Coluna sem cartão: "Nenhum item".
   Não levar projeto, tarefa nem natureza para o modelo genérico. */}`,
  },
  table: {
    importName: 'MaterialReactTable',
    usage: `import MaterialReactTable from 'material-react-table'
import { MRT_Localization_PT } from 'material-react-table/locales/pt'

<MaterialReactTable
  columns={columns}
  data={rows}
  localization={MRT_Localization_PT}
  enableColumnFilters
  enableGlobalFilter
  enableDensityToggle={false}
  initialState={{ density: 'compact' }}
/>`,
  },
  kpi: {
    importName: 'KpiCard',
    usage: `<KpiCard appearance="simple" label="Projetos ativos" value={128} />

{/* appearance: "simple" | "trend" | "goal" */}`,
  },
  'card-panel': {
    importName: 'CardPanel',
    usage: `<CardPanel appearance="basic" title="Resumo" actions={<>…</>}>
  {/* conteúdo */}
</CardPanel>

{/* appearance: "basic" | "withFooter" | "withTag" */}`,
  },
  filter: {
    importName: 'MaterialReactTable',
    usage: `{/* Filtro da listagem = enableColumnFilters do MaterialReactTable. Não criar barra paralela. */}`,
  },
  'form-layout': {
    importName: 'FormLayout',
    usage: `<FormLayout appearance="oneColumn">{/* fields */}</FormLayout>

{/* appearance: "oneColumn" | "twoColumns" | "accordion" */}`,
  },
  tabs: {
    importName: 'Tabs',
    usage: `import { Nav, NavItem, NavLink } from 'reactstrap'

<Nav tabs className="nav-tabs-custom">
  <NavItem>
    <NavLink className={classnames({ active: tab === 'dados' })} onClick={() => setTab('dados')}>
      Dados
    </NavLink>
  </NavItem>
</Nav>`,
  },
  accordion: {
    importName: 'Accordion',
    usage: `<Accordion appearance="single" sections={secoes} />

{/* appearance: "single" | "multiple" | "dense" */}`,
  },
  'page-header': {
    importName: 'PageHeader',
    usage: `<PageHeader appearance="withActions" title="Contratos" actions={<>…</>} />

{/* appearance: "titleOnly" | "breadcrumb" | "withActions" */}`,
  },
  nav: {
    importName: 'AppNav',
    usage: `<AppNav appearance="topbar" items={modulos} activeId="projetos" />

{/* appearance: "topbar" | "sidebar" | "topbarTabs" */}`,
  },
  'modal-confirm': {
    importName: 'ConfirmModal',
    usage: `<ConfirmModal open={open} appearance="simple" title="Confirmar?" onConfirm={ok} onCancel={fechar} />

{/* appearance: "simple" | "alert" | "destructive" */}`,
  },
  'modal-form': {
    importName: 'FormModal',
    usage: `<FormModal open={open} appearance="md" title="Novo" onSubmit={salvar} onCancel={fechar}>{/* fields */}</FormModal>

{/* appearance: "sm" | "md" | "lgTabs" */}`,
  },
  drawer: {
    importName: 'Drawer',
    usage: `<Drawer open={open} appearance="read" title="Detalhe" onClose={fechar}>{/* … */}</Drawer>

{/* appearance: "read" | "edit" | "filters" */}`,
  },
  loading: {
    importName: 'LoadingState',
    usage: `<LoadingState appearance="spinner" label="Carregando…" />

{/* appearance: "spinner" | "skeleton" | "inline" */}`,
  },
  'alert-banner': {
    importName: 'AlertBanner',
    usage: `<AlertBanner appearance="error" message="Não foi possível salvar." />

{/* appearance: "error" | "warning" | "infoAction" */}`,
  },
  toast: {
    importName: 'toast',
    usage: `toast.success("Salvo com sucesso", { appearance: "corner" })

{/* appearance: "corner" | "bottomBar" | "inline" */}`,
  },
  empty: {
    importName: 'EmptyState',
    usage: `<EmptyState appearance="cta" title="Nenhum registro" actionLabel="Criar" onAction={criar} />

{/* appearance: "cta" | "illustration" | "quiet" */}`,
  },
  'status-badge': {
    importName: 'StatusBadge',
    usage: `<StatusBadge appearance="pill" status="aprovado" />

{/* appearance: "pill" | "dot" | "outline" */}`,
  },
  stepper: {
    importName: 'Stepper',
    usage: `<Stepper appearance="horizontal" steps={["Aberto","Análise","Fim"]} current={1} />

{/* appearance: "horizontal" | "numbered" | "timeline" */}`,
  },
  upload: {
    importName: 'FileUpload',
    usage: `<FileUpload appearance="buttonList" files={anexos} onChange={setAnexos} />

{/* appearance: "buttonList" | "dropzone" | "thumbs" */}`,
  },
  chart: {
    importName: 'Chart',
    usage: `<Chart appearance="bars" series={[{ name: "Receita", data: [] }]} />

{/* appearance: "bars" | "line" | "pie" */}`,
  },
  approval: {
    importName: 'ApprovalCard',
    usage: `<ApprovalCard appearance="actionsRight" title="Pedido #881" onApprove={ok} onReject={no} />

{/* appearance: "actionsRight" | "fullWidth" | "withReason" */}`,
  },
  money: {
    importName: 'MoneyDisplay',
    usage: `<MoneyDisplay appearance="hero" value={12450} label="Saldo disponível" />

{/* appearance: "hero" | "breakdown" | "ledger" */}`,
  },
}

export default ATOM_USAGE
